import * as React from 'react';

import {Button} from 'shells/button/button';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {TwoPaneModal} from 'shells/modal/two-pane-modal';
import {Body} from 'shells/typography/body';

import {analyticsClient} from '../../analytics-client';

import {useNutshellSurvey} from '../internal-feedback/hooks/use-nutshell-survey';

import {useGetReview} from './graphql/hooks/use-get-review';

import styles from './leave-a-review-modal.module.css';

type Props = {
    onClose: () => void;
};

export function LeaveAReviewModal(props: Props) {
    const [isTwoPaneModalOpen, setIsTwoPaneModalOpen] = React.useState<boolean>(true);

    const {openSurvey, SurveyModal} = useNutshellSurvey({
        onClose: props.onClose,
    });
    const {review} = useGetReview();

    // Track when the modal is opened
    React.useEffect(() => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_LEAVE_A_REVIEW_MODAL_VIEWED);
    }, []);

    const handleLeaveReviewClick = () => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_LEAVE_A_REVIEW_CLICKED);
    };

    const handleShareFeedbackClick = () => {
        setIsTwoPaneModalOpen(false);
        openSurvey();
    };

    const leftSection = (
        <div className={styles['left-section']}>
            <Illustration src='leave-a-review' width={300} />
        </div>
    );

    const rightSection = (
        <div className='flex align-center pad-32 pos-relative'>
            <Stack>
                <Stack spacing={16}>
                    <Body size='xlarge' isBold={true}>
                        Do you love using Nutshell?
                    </Body>
                    <Body>
                        A positive review helps more businesses discover Nutshell, leading to better
                        features for you!
                    </Body>
                    <Body>
                        Leaving a review takes under 10 minutes. Just click ’Leave a review’.
                    </Body>
                    <Body>
                        Got feedback or ideas for us? We’d love to hear! Click ’Share feedback’ to
                        let us know.
                    </Body>
                </Stack>
                <div className='pos-absolute bottom-0 right-0 mb-32 mr-32'>
                    <Stack isHorizontal={true} spacing={8}>
                        <Link
                            variant='button-primary'
                            href={review && review.reviewLink}
                            newTab={true}
                            onClick={handleLeaveReviewClick}
                        >
                            Leave a review
                        </Link>
                        <Button variant='primary' onClick={handleShareFeedbackClick}>
                            Share feedback
                        </Button>
                    </Stack>
                </div>
            </Stack>
        </div>
    );

    return (
        <>
            {isTwoPaneModalOpen && (
                <TwoPaneModal
                    // @ts-expect-error
                    isOpen={true}
                    onClose={props.onClose}
                    leftSection={leftSection}
                    rightSection={rightSection}
                    maxHeight={600}
                />
            )}
            {SurveyModal}
        </>
    );
}
